(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:MessageManagerModalCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('MessageManagerModalCtrl', MessageManagerModalCtrl);

    function MessageManagerModalCtrl($uibModalInstance, CommonMasterData, RemoteService, applicationConstants,
    		modalParams, MessageService, CrewingHelper, CrewingRequest, EventManagerService) {
        var vm = this;
        vm.model = {
        		SMSListSearch: {
        			crewBase : [],
        			status : []
        		},
        		EmailListSearch: {
        			
        		},
        		request : {
        			fromDate : moment().format("DD/MM/YYYY"),
            		toDate : moment().add(1,'d').format("DD/MM/YYYY"),
            		refreshStatus : false,
            		crewBase : '',
            		status : null,
            		pageSize : 60,
            		startPosition : 1,
            		crewProfileId : modalParams != null ? modalParams.crew.crewDTO.crewProfileId : null,
        		},
        		fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
        		SMSList: {},
        		EmailList: {}
        };
        
        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        vm.searchSMSList = function () {
        	if(isValidSearchParams() && !!vm.searchAny && vm.searchAny.$valid) {
        		if(document.querySelector('.tableBodyScroll tbody') != null) {
            		document.querySelector('.tableBodyScroll tbody').scrollTop = 0;        		
            	}
            	vm.model.request.startPosition = 1,
            	CrewingHelper.searchSMSList(vm.model.request, function(data) {
    	        		vm.model.SMSList = data;
    	        	},
    	        	function(error) {
    	        		MessageService.error(error.msg[0]);
    	        });        		
        	}
        }
		
		vm.changeSearchField = function(flag) {
			if (flag === 'fromDate') {
				setDateValidationFlags();
				if (vm.model.request.fromDate) {
                    var moEnd = moment(vm.model.request.fromDate, applicationConstants.SETTINGS.DATE_FORMAT).endOf("month");
                    vm.model.request.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                }
			}
		};
		
		function isValidSearchParams() {
			setDateValidationFlags();
			// if date invalid
			if(!isFromDateBeforeToDate()) {
				vm.model.fromDateAfterToDate = true;
			} else {
				vm.model.fromDateAfterToDate = false;
			}
			
			if (vm.model.toDateFormatInvalid
					|| vm.model.fromDateFormatInvalid
					|| vm.model.fromDateAfterToDate) {
				return false;
			} else {
				return true;
			}
		}
		
		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.request.fromDate)) {
				vm.model.fromDateFormatInvalid = true;
			} else {
				vm.model.fromDateFormatInvalid = false;
			}
			// if to date invalid
			if (isDateFormatInvalid(vm.model.request.toDate)) {
				vm.model.toDateFormatInvalid = true;
			} else {
				vm.model.toDateFormatInvalid = false;
			}
		}
		
		// check from date and to date
		function isFromDateBeforeToDate() {
			return moment(vm.model.request.fromDate,"DD/MM/YYYY").isBefore( moment(vm.model.request.toDate, "DD/MM/YYYY")) 
			|| moment(vm.model.request.fromDate,"DD/MM/YYYY").isSame(moment(vm.model.request.toDate, "DD/MM/YYYY"));
		};
		
		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}
		
		function getNextSetOfRecords() {
			if (vm.model.SMSList &&
	                vm.model.SMSList.totalRecords &&
	                vm.model.request.startPosition + vm.model.request.pageSize < vm.model.SMSList.totalRecords
	            ) {
	                vm.model.request.startPosition = vm.model.request.startPosition + vm.model.request.pageSize;
	                getDataForElasticSearch();
	            }
			else {
				var lastPageStartPos = vm.model.SMSList.totalRecords - vm.model.request.pageSize;
                if (vm.model.request.startPosition < lastPageStartPos) {
                    vm.model.request.startPosition = lastPageStartPos;
                    getDataForElasticSearch();
                }
			}
		}
		
		function getDataForElasticSearch() {
			CrewingHelper.searchSMSList(vm.model.request, function(newSMSList) {
        		CrewingHelper.appendToSMSList(vm.model.SMSList, newSMSList);
        	},
        	function(error) {
        		MessageService.error(error);
		    });
		}

        (function() {
        	CommonMasterData.getCrewBaseList(
                    function (baseTypes) {
                        vm.model.SMSListSearch.crewBase = baseTypes;
                    },
                    function () {
                        console.log('Crew Base type retrieval error');
                    }
                ); 
			CommonMasterData.searchStatusOfMsgs(function(msgStatusList) {
				vm.model.SMSListSearch.status = msgStatusList;
			}, function() {
				console.log('Message Status list retrieval error');
			});
        	vm.searchSMSList();
        })();
    }
}());
